import SessionManager from '../utils/sessionManager';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://aptirix-version-610696728606.asia-south1.run.app/api';

function getAuthHeaders() {
  let currentSession = SessionManager.getCurrentSession();
  if (!currentSession || !currentSession.access_token) {
    currentSession = SessionManager.getSession('candidate');
  }
  const token = currentSession?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/**
 * Call backend TTS (Chirp 3 HD). Returns an audio Blob (MP3).
 */
export async function textToSpeech(text, languageCode = 'en-US', voiceName = null) {
  const body = {
    text,
    language_code: languageCode,
  };
  if (voiceName) body.voice_name = voiceName;

  const response = await fetch(`${API_BASE_URL}/speech/tts`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errText = await response.text().catch(() => 'Unknown error');
    throw new Error(`TTS failed (${response.status}): ${errText}`);
  }

  return response.blob();
}
